export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('branchoffice_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "address",
          name: t('branchoffice_form_address'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "city",
          name: t('branchoffice_form_city'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "state",
          name: t('branchoffice_form_state'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "zip_code",
          name: t('branchoffice_form_zip_code'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "phone",
          name: t('branchoffice_form_phone'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "whatsapp",
          name: t('branchoffice_form_whatsapp'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "email",
          name: t('branchoffice_form_email'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "logo",
          name: t('branchoffice_form_logo'),
          type: "image",
          required: false,
          isImage: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "active",
          name: t('branchoffice_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}